import { Button, Menu, MenuItem } from '@mui/material'
import cn from 'classnames'
import { useState } from 'react'
import { useRefinementList } from 'react-instantsearch'
import { ExtendedRefinementListItem } from '../types'

type RefinementsMenuItemProps = ExtendedRefinementListItem

export function RefinementsMenuItem({
  label,
  icon,
  ...refinementListProps
}: RefinementsMenuItemProps) {
  const { attribute } = refinementListProps
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const { items, createURL, refine, canRefine } =
    useRefinementList(refinementListProps)

  const hasRefinedItems = items.some((item) => item.isRefined)

  const buttonId = `refinement-${attribute.replace(/\./g, '-')}`
  const menuId = `${buttonId}-menu`

  return (
    <>
      <Button
        id={buttonId}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant="outlined"
        disabled={!canRefine}
        startIcon={icon}
        className={cn(
          'border-divider-light',
          hasRefinedItems ? 'bg-lines/50' : ''
        )}
      >
        {label}
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': buttonId,
          },
        }}
      >
        {items.map((item) => (
          <MenuItem
            href={createURL(item.value)}
            key={item.label}
            onClick={(e) => {
              e.preventDefault()
              handleClose()
              refine(item.label)
            }}
            selected={item.isRefined}
            disableGutters
            disableRipple
            disableTouchRipple
          >
            <div className="flex w-full items-center gap-2">
              <span className="text-sm font-medium">{item.label}</span>
              <span
                className={cn(
                  'ml-auto text-sm',
                  item.isRefined ? 'opacity-100' : 'opacity-65'
                )}
              >
                {item.count}
              </span>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
